import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import CardLoader from "../components/CardLoader";

import { useDispatch, useSelector } from "react-redux";
import * as idiImportActions from "../actions/IdiImportActions";

const IdiImportScreen  = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const loading = useSelector((state) => state.idiimport.loading);
    const fbo = useSelector((state) => state.idiimport.fbo);
    
    const [fboState, setFBOState] = React.useState(null);
    const [selectedFile, setSelectedFile] = React.useState(null);

    React.useEffect(() => {
		setFBOState(fbo);
    }, [fbo]);

    const onFileChange = (event) => {
        if(event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
        }
    }

    const onImportIdiFile = async() => {
        if(selectedFile) {
            const formData = new FormData();
            formData.append("file", selectedFile, selectedFile.name);

            dispatch(idiImportActions.importIdiFile(formData, navigate));
        }
    }

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={"IDI Import"} />
                    <Row>
                        <Col lg={12}>
                            <CardLoader loading={loading} />

                            <Card>
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">IDI Import</h5>
                                    <div className="flex-shrink-0">
                                        <div className="d-flex flex-wrap gap-2">
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || selectedFile === null}
                                                onClick={onImportIdiFile}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Start Import
                                            </button>
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <div className="mb-3">
                                            <label className="form-label">Select File</label>
                                            <input className="form-control" type="file" onChange={onFileChange} />
                                        </div>
                                        {fboState && fboState.recordCount &&
                                        <Fragment>
                                            <Col xxl={12} md={12}>
                                                <div class="alert alert-success" role="alert">
                                                    <b><i className="ri-checkbox-circle-fill label-icon align-middle fs-2 me-1"></i></b>
                                                    <b>{fboState && fboState.recordCount || ""}</b> Records Imported Successfully
                                                </div>
                                            </Col>
                                            <Col xxl={12} md={12}>
                                                <button className="btn btn-primary btn-label"
                                                    disabled={loading}
                                                    onClick={onImportIdiFile}
                                                >
                                                    <i className="ri-save-line label-icon align-middle"></i> Process Imported Records
                                                </button>
                                            </Col>
                                        </Fragment>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IdiImportScreen;